export default __webpack_public_path__ + "static/media/IMG-20241005-WA0040.c2e6733b.jpg";